import React from 'react';
import { Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="md:col-span-1">
            <div className="mb-6">
              <div className="text-3xl font-bold">
                <span className="text-[#d97841]">FXC</span>
                <span className="text-white"> Management Services</span>
              </div>
              <div className="h-0.5 w-32 bg-[#0d6571] mt-2"></div>
            </div>
            <p className="text-gray-400 leading-relaxed mb-6">
              Empowering businesses with cutting-edge financial insights and strategic
              guidance. We help you navigate the complex world of investments,
              sustainability, and digital transformation.
            </p>
            <div className="space-y-3">
              <div className="flex items-center space-x-3 text-gray-400">
                <Mail className="w-5 h-5 text-[#d97841]" />
                <a href="mailto:info@fxcvantage.com" className="hover:text-[#d97841] transition-colors">
                  info@fxcvantage.com
                </a>
              </div>
              <div className="flex items-start space-x-3 text-gray-400">
                <MapPin className="w-5 h-5 text-[#d97841] flex-shrink-0 mt-1" />
                <div>
                  <p className="font-semibold text-white mb-1">FXC Management Services B.V.</p>
                  <p>Industrieweg 9</p>
                  <p>2254AE Voorschoten</p>
                  <p>The Netherlands</p>
                  <p className="mt-2 text-sm">
                    Registered at the Chamber of Commerce under 78204992
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="/"
                  className="text-gray-400 hover:text-[#d97841] transition-colors"
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  href="/services"
                  className="text-gray-400 hover:text-[#d97841] transition-colors"
                >
                  Services
                </a>
              </li>
              <li>
                <a
                  href="/partners"
                  className="text-gray-400 hover:text-[#d97841] transition-colors"
                >
                  Partners
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="text-gray-400 hover:text-[#d97841] transition-colors"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-xl font-bold mb-6">Services</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="/marketing"
                  className="text-gray-400 hover:text-[#d97841] transition-colors"
                >
                  Marketing Strategy
                </a>
              </li>
              <li>
                <a
                  href="/marketing"
                  className="text-gray-400 hover:text-[#d97841] transition-colors"
                >
                  Market Intelligence
                </a>
              </li>
              <li>
                <a
                  href="/marketing"
                  className="text-gray-400 hover:text-[#d97841] transition-colors"
                >
                  Custom Research
                </a>
              </li>
              <li>
                <a
                  href="/big-data-analytics"
                  className="text-gray-400 hover:text-[#d97841] transition-colors"
                >
                  Data Analytics
                </a>
              </li>
              <li>
                <a
                  href="/big-data-analytics"
                  className="text-gray-400 hover:text-[#d97841] transition-colors"
                >
                  Reserve Optimization
                </a>
              </li>
              <li>
                <a
                  href="/sustainability"
                  className="text-gray-400 hover:text-[#d97841] transition-colors"
                >
                  Sustainability
                </a>
              </li>
              <li>
                <a
                  href="/ai-consulting"
                  className="text-gray-400 hover:text-[#d97841] transition-colors"
                >
                  AI Consulting
                </a>
              </li>
              <li>
                <a
                  href="/ai-consulting"
                  className="text-gray-400 hover:text-[#d97841] transition-colors"
                >
                  VPS Management
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-xl font-bold mb-6">Legal</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="/privacy-policy"
                  className="text-gray-400 hover:text-[#d97841] transition-colors"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="/terms-of-service"
                  className="text-gray-400 hover:text-[#d97841] transition-colors"
                >
                  Terms of FXC Services
                </a>
              </li>
              <li>
                <a
                  href="/cookie-policy"
                  className="text-gray-400 hover:text-[#d97841] transition-colors"
                >
                  Cookie Policy
                </a>
              </li>
              <li>
                <a
                  href="/gdpr"
                  className="text-gray-400 hover:text-[#d97841] transition-colors"
                >
                  GDPR & Data Protection
                </a>
              </li>
              <li>
                <a
                  href="/aml-ctf"
                  className="text-gray-400 hover:text-[#d97841] transition-colors"
                >
                  AML/CTF Compliance
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © 2025 FXC Management Services. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
